import { render } from "./BlogDetail.vue?vue&type=template&id=ead8e534"
import script from "./BlogDetail.vue?vue&type=script&lang=ts"
export * from "./BlogDetail.vue?vue&type=script&lang=ts"
script.render = render

export default script